import http from 'axios'

const state = {
  infobit: undefined,     // the displayed infobit (object), or undefined if no infobit is displayed
                          // Must be consistent with "infobitId" root state.
  backlinks: [],          // A list of infobits mentioning (linking to) the current "infobit"
  editable: false,        // is the displayed infobit editable by the current user?
  mode: 'info',           // "info" or "form"
  formAction: undefined,  // "create" or "update"
  contextTrees: [],       // All trees which contain selected infobit or empty array when no infobit is selected
  quillEditor: undefined, // reference to the quill-editor-vue component (if available/rendered)
  htmlField: undefined,   // reference to the html-field.vue component
  selectedText: undefined, // if set, represents the future label of an infobit-link
  textCursorRange: { index: 0, range: 0 }, // once editor has become "focus" has always the "range"
    // object of "quill" assigned representing the latest cursor position index
    // supports only 1 html-field instance per detail-panel
  treeContextSelector: {
    show: false,
    posX: 0,
    posY: 0,
    trees: [],
    sourceInfobitId: 0
  }
}

const actions = {

  newInfobit ({state, dispatch}, type) {
    console.log('newInfobit', type)
    dispatch('deselectInfobit')
    state.infobit = {
      type,
      details: {}
    }
    state.mode = 'form'
    state.formAction = 'create'
  },

  editInfobit ({state}) {
    state.mode = 'form'
    state.formAction = 'update'
  },

  submitInfobit ({state, rootState, dispatch}) {
    console.log('submitInfobit', state.infobit)
    state.mode = 'info'
    state.editable = true
    switch (state.formAction) {
      case 'create':
        http.post('/infobits/infobit', state.infobit).then(response => {
          var infobit = response.data
          rootState.infobitId = infobit.id
          state.infobit = infobit
        })
        break
      case 'update':
        http.put('/infobits/infobit/' + state.infobit.id, state.infobit)
        break
    }
  },

  selectInfobit ({state, rootState, dispatch}, infobitId) {
    // argument check
    if (typeof infobitId !== 'number') {
      throw Error('IllegalArgumentException: a ' + typeof infobitId + ' ("' + infobitId + '") is passed as ' +
        '"infobitId" to the "selectInfobit" action when a number is expected')
    }
    //
    rootState.infobitId = infobitId
    state.mode = 'info'
    dispatch('refreshInfobit')
    http.get('/accesscontrol/topic/' + infobitId).then(response => {
      state.editable = response.data['dm4.accesscontrol.operation.write']
    })
    buildBacklinks(infobitId)
  },

  onSelectInfobit ({state, dispatch}, infobitId) {
    // init list of trees containing this infobit
    http.get('/infobits/tree/infobit/' + infobitId).then(response => {
      state.contextTrees = response.data
    })
  },

  toggleLinkTreeSelector ({state, dispatch}, infobit) {
    // console.log('toggleLinkTreeSelector', infobit.id, 'Event', infobit.mouseEvent)
    var event = infobit.mouseEvent
    state.treeContextSelector.sourceInfobitId = infobit.id
    dispatch('fetchTrees', infobit.id).then(entries => {
      state.treeContextSelector.trees = entries
      if (!state.treeContextSelector.show) {
        state.treeContextSelector.show = true
      } else {
        dispatch('hideLinkTreeSelector')
      }
      if (event) {
        state.treeContextSelector.posY = (event.clientY - 30)
        state.treeContextSelector.posX = (event.clientX + 10)
      }
    })
  },

  deselectInfobit ({state, rootState}) {
    state.infobit = undefined
    state.contextTrees = []
    rootState.infobitId = undefined
    state.backlinks = []
  },

  deselectInfobitIfSelected ({rootState, dispatch}, infobitId) {
    if (rootState.infobitId === infobitId) {
      dispatch('deselectInfobit')
    }
  },

  refreshInfobit ({state, dispatch, rootState}) {
    http.get('/infobits/infobit/' + rootState.infobitId).then(response => {
      state.infobit = response.data
    })
  },

  hideLinkTreeSelector ({state}) {
    state.treeContextSelector.show = false
    state.treeContextSelector.trees = []
  },

  fetchTrees ({rootState}, infobitId) {
    return http.get('/infobits/tree/infobit/' + infobitId).then(response => response.data)
  },

  fetchInfobit ({state}, {infobitId}) {
    return http.get('/infobits/infobit/' + infobitId).then(response => response.data)
  },

  createInfobitLink ({state}, {sourceInfobit, targetInfobit}) {
    // generating html title attribute for the internal link and writing it into the HTML value field...
    // FIXME: display hover information like "title of linked infobit" on demand
    var infobitView = {
      htmlTitle: 'Infobit "' + targetInfobit.title + '"', title: targetInfobit.title, id: targetInfobit.id
    }
    var opsDelta = {}
    console.log('createInfobitLink textSelection', state.selectedText, 'range', state.textCursorRange)
    // Create infobit.link assoc in backend, then format infobit-link
    http.post('/infobits/link/source/' + sourceInfobit.id + '/target/' + targetInfobit.id)
      .then(response => {
        infobitView.linkId = response.data.id  // infobit-link association id
        if (state.selectedText) { // take current text selection as link label and encode infobit
          opsDelta = state.quillEditor.format('infobitLink', infobitView)
        } else { // insert infobit title as new text, format that as an infobit link and move cursor
          opsDelta = state.quillEditor.insertText(state.textCursorRange.index, infobitView.title,
            'infobitLink', infobitView)
        }
        console.log('created infobitLinkAssociation target', targetInfobit, 'source', sourceInfobit,
          state.selectedText, opsDelta)
      })
  },

  deleteInfobitLinkAssoc ({state}, {assocId}) {
    console.log('deleteInfobitLinkAssoc', assocId)
    return http.delete('/infobits/link/' + assocId).then(response => response.data, error => error)
  }

}

export default {
  state,
  actions
}

function buildBacklinks (infobitId) {
  http.get('/infobits/link/target/' + infobitId).then(response => {
    state.backlinks = response.data
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/detail-panel.js